export type ServiceItem = { name: string; extra?: number };

export function parseLangsString(langsString?: string): { isocode: string; score: number }[] {
  if (!langsString || typeof langsString !== 'string') return [];
  return langsString.split(',').map(lang => {
    const [isocode, score] = lang.split('|');
    return {
      isocode: isocode || '',
      score: score ? Number(score) : 0
    };
  }).filter(l => l.isocode);
}

export function parseServicesString(services: string | string[] | undefined): ServiceItem[] {
  if (Array.isArray(services)) {
    return services.map(s => ({ name: s }));
  }
  if (typeof services !== 'string' || !services.trim()) return [];

  const servs = services.split(',').map(raw => {
    const [name, extra] = raw.split('+');
    return extra
      ? { name: name.trim(), extra: Number(extra) }
      : { name: name.trim() };
  });

  return servs;
}

export function parseBlockedLocation(location: string): string[] {
  if (!location) return [];
  return location.split('|').filter(Boolean);
}

export function formatServiceItem(item: ServiceItem): string {
  return item.extra ? `${item.name} (+${item.extra}€)` : item.name;
}

export function formatServicesList(services: ServiceItem[]): string {
  return services.map(formatServiceItem).join(', ');
}
